import React, { useContext, useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Row } from 'reactstrap'
import GroupCred from './GroupCred';
import GroupFlexCred from './GroupFlexCred';
import CredContext from './Creds';

function CredData({ apptSys, onCancel, onEdit }) {

  const { apptSysTypes, fetchAllApptSys } = useContext(CredContext);
  const[creds, setCreds] = useState([])

  const setCredentials = (creds) => {
    setCreds(creds)
  }

  // Fetch appointment system types on mount to get cred_fields metadata
  useEffect(() => {
    if (!apptSysTypes || apptSysTypes.length === 0) {
      fetchAllApptSys();
    }
  }, []);

  // Find the appointment system type to check for cred_fields
  const selectedApptSys = (apptSysTypes || []).find(x => x.key === apptSys.appt_sys);
  const credFields = selectedApptSys?.cred_fields || [];
  const usesFlexCreds = credFields.length > 0;

  useEffect(() => {
    if (usesFlexCreds) {
      // Dynamic fields - extract all non-object fields at root for default
      const defaultCreds = Object.entries(apptSys.creds || {})
        .filter(([, value]) => typeof value !== "object" || value === null)
        .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

      const result = [
        {
          group_name: "default",
          ...defaultCreds,
        },
        ...Object.entries(apptSys.creds || {})
          .filter(([key, value]) => typeof value === 'object' && value !== null)
          .map(([group_name, credentials]) => ({
            group_name,
            ...credentials
          }))
      ];
      setCreds(result)
    } else {
      // Legacy userId/password pattern
      const result = [
        {
          group_name: "default",
          userId: apptSys.creds?.userId,
          password: apptSys.creds?.password
        },
        ...Object.entries(apptSys.creds || {}).filter(([key, value]) => typeof value === 'object' && value !== null).map(([group_name, credentials]) => ({
          group_name,
          ...credentials
        }))
      ];
      setCreds(result)
    }
  }, [apptSys, usesFlexCreds])

  return (
    <Card>
      {creds.length > 0 &&<CardBody>
        <Row className='mb-4'>
          <Col><h5 className='text-primary'>Credential Details</h5></Col>
          <Col><div className="flex text-end me-3"><i className="mdi mdi-pencil font-size-16 text-primary me-1 pointer" onClick={onEdit}/></div></Col>
        </Row>
        <Row className="mb-3">
          <Col md={3}>
            <span className="text-muted">Appointment System:</span>
          </Col>
          <Col md={9}>
            <span>{apptSys.appt_sys}</span>
          </Col>
        </Row>
        
        {usesFlexCreds ? (
          <GroupFlexCred
            creds={creds}
            credFields={credFields}
            isEdit={false}
            setCreds={setCredentials}
          />
        ) : (
          <GroupCred creds={creds} setCreds={setCredentials}/>
        )}

        <div className="modal-footer">
          <Button
            color="secondary"
            className="btn btn-sm btn-soft"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </CardBody>}
    </Card>
  )
}

export default CredData
